/**
 * @description 패스워드 검사 함수
 * @param password
 * @returns
 */
export const passwordChecker = (password) => {
  return password.toString().match(/(?=.*\d)(?=.*[a-z]).{8,}/);
};

/**
 * @description 이메일 검사 함수
 * @param email
 * @returns
 */
export const emailChecker = (email) => {
  return email.toString().match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/);
};

/**
 * @description 폰 번호 검사 함수
 * @param phoneNum
 * @returns
 */
export const phoneChecker = (phoneNum) => {
  return phoneNum.toString().match(/^[0-9]{3}[-]+[0-9]{4}[-]+[0-9]{4}$/);
};

/**
 * @description 타입별 유효성 검사
 * @param {*} type password, email, phone
 * @param {*} string
 * @returns
 */
export const integratedValidator = (type, string) => {
  switch (type) {
    case 'password':
      return passwordChecker(string);
    case 'email':
      return emailChecker(string);
    case 'phone':
      return phoneChecker(string);
    default:
      break;
  }
};
